import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierPlanDetail extends Layout {
    labelD: Label;
    sourceCarrierPlanDetail: DataSource;
    textboxActivityId: Textbox;
    textboxDays: Textbox;
    textboxDescr: Textbox;
    textboxPriority: Textbox;
}
